import BaseSchema from "./base";

class Document extends BaseSchema {
  static primaryKey = "uuid";
  static tableName = "documents";
  static fields = [
    "uuid",
    "createdAt",
    "updatedAt",
    "tags",
    "servicesRelatedName",
    "originId",
    "oldOriginId",
    "origin",
    "gedProjectId",
    "name",
    "source",
    "ref",
    "datetime",
    "version",
    "docType",
    "docStatus",
    "metaDatas",
    "relatedObjects",
    "isActive",
    "filename",
    "projects",
    "mimeType",
    // INFO - PH - 30/08/2022 - Front specific fields
    "isLoaded",
  ];

  static relatedFields = {
    projects: {
      m2m: true,
      tableName: "projects",
      relatedKey: "relatedObjects",
      owner: true,
    },
  };

  static dateFields = ["createdAt", "updatedAt", "datetime", "issue_date"];

  static dateTimeFields = ["datetime"];
}

export default Document;
